import { JaneDM } from '@iheartjane/dm-sdk';
import { debugLog } from '@iheartjane/tracking';
import { Storage } from '@iheartjane/utils';

const NANOID_LENGTH = 21;

export const jdidIsNano = (jdid: string | null | undefined): boolean => {
  return jdid?.length === NANOID_LENGTH;
};

export const generateFallbackJdid = () => {
  return JaneDM.generateJaneDeviceId();
};

export const getJaneDeviceId = (documentCookie = document.cookie) => {
  const jdidKey = 'jdid';
  const availableId = Storage.get<string>('jdid');
  if (availableId) {
    return availableId;
  }
  const cookie = getCookie('jdid', documentCookie);
  if (cookie) {
    Storage.set(jdidKey, cookie);
    return cookie;
  }
  debugLog(
    'JDID not available was not available in getJaneDeviceId. No reason for alarm.'
  );
  const newId = generateFallbackJdid();
  Storage.set(jdidKey, newId);
  return newId;
};

export const getCookie = (
  name: string,
  documentCookie = document.cookie
): string | null => {
  const cookieValue = documentCookie
    .split(';')
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(`${name}=`));
  return cookieValue ? decodeURIComponent(cookieValue.split('=')[1]) : null;
};

export interface LocalStorageWithTTL {
  expiry: number;
  value: string;
}

export function getLocalStorageWithTTL(key: string) {
  const itemStr = Storage.get<string>(key);
  if (!itemStr) return null;
  try {
    const { value, expiry } = JSON.parse(itemStr) as LocalStorageWithTTL;
    return Date.now() > expiry ? null : value;
  } catch {
    console.log('error parsing JSON', { itemStr, key });
    Storage.remove(key);
    return null;
  }
}
